const authRoutes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("./pages/Login.vue"),
    meta: {
      auth: false
    }
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("./pages/Logout.vue")
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./pages/Register.vue")
  },
  {
    path: "/recover",
    name: "Recover",
    component: () => import("./pages/Recover.vue")
  },
  {
    path: "/password",
    name: "Password",
    component: () => import("./pages/Password.vue")
  },
  {
    path: "/cannot_access",
    name: "CannotAccess",
    component: () => import("./pages/CannotAccess.vue")
  }
];

export default authRoutes;
